import { useState } from 'react';
import { Plus, Clock, Trash2 } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';
import Modal from '../ui/Modal';

const Sidebar = () => {
  const {
    theme,
    conversations,
    activeConversationId,
    setActiveConversationId,
    handleNewChat,
    isSidebarOpen,
    deleteConversation,
  } = useAppContext();

  const [deleteTarget, setDeleteTarget] = useState(null);

  const openDeleteModal = (event, convoId) => {
    event.stopPropagation();
    setDeleteTarget(convoId);
  };

  const confirmDelete = () => {
    if (deleteTarget) {
      deleteConversation(deleteTarget);
      setDeleteTarget(null);
    }
  };

  const closeDeleteModal = () => {
    setDeleteTarget(null);
  };

  return (
    <>
      <div className={`flex flex-col p-4 sidebar-container transition-transform duration-300 ${
        isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
      }`}>
        <div className="flex items-center gap-2 mb-4 ">
          <button 
            onClick={handleNewChat} 
            className="flex-grow flex items-center justify-center gap-2 bg-gray-800 text-white rounded-lg p-3 font-semibold hover:bg-gray-700 transition-colors"
          >
            <Plus size={16}/> New Chat 
          </button>
        </div>
        
        <div className="flex-grow overflow-y-auto">
          <div className="mb-2">
            <div className="flex items-center gap-2 mb-4">
            <Clock size={18} className={`${theme === 'dark' ? 'bg-black' : 'bg-white'}text-blue-400`} />
            <h2 className="text-sm font-semibold text-gray-400 uppercase tracking-wider">
              Recent Chats
            </h2>
          </div>
            <div className="flex flex-col space-y-1">
              {Object.entries(conversations).map(([convoId, convo]) => (
                <div 
                  key={convoId} 
                  className={`flex items-center justify-between gap-2 p-3 rounded-lg mb-1 cursor-pointer transition-colors ${
                    activeConversationId === convoId 
                      ? (theme === 'dark' ? 'bg-gray-800' : 'bg-gray-200') 
                      : (theme === 'dark' ? 'hover:bg-gray-800' : 'hover:bg-gray-100')
                  }`} 
                  onClick={() => setActiveConversationId(convoId)}
                >
                  <p className={`${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'} truncate text-sm`}>
                    {convo.title}
                  </p>
                  <button
                    type="button"
                    onClick={(event) => openDeleteModal(event, convoId)}
                    className={`p-1 rounded-lg transition-colors ${
                      theme === 'dark'
                        ? 'text-gray-400 hover:text-red-400 hover:bg-gray-900'
                        : 'text-gray-500 hover:text-red-500 hover:bg-gray-200'
                    }`}
                    aria-label="Delete conversation"
                    title="Delete conversation"
                  >
                    <Trash2 size={16} />
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Modal
        isOpen={Boolean(deleteTarget)}
        onClose={closeDeleteModal}
        title="Delete conversation?"
        maxWidthClass="max-w-sm"
      >
        <p className={`${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'} mb-4`}>
          This will remove “{conversations[deleteTarget]?.title || 'this conversation'}” and its messages from this device.
        </p>
        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={closeDeleteModal}
            className={`px-4 py-2 rounded-lg border transition-colors ${
              theme === 'dark'
                ? 'border-gray-700 text-gray-200 hover:bg-gray-800'
                : 'border-gray-300 text-gray-800 hover:bg-gray-100'
            }`}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={confirmDelete}
            className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition-colors"
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
};

export default Sidebar;
